import { mapGetters } from 'vuex';

import CourseMixin from '@/mixins/templates/course';
import ContentMixin from '@/mixins/templates/content';
import ContentSyncMixin from '@/mixins/content-sync';


import SidebarMenu from './sidebar-menu';
import TopicNavigation from '@/components/content-v2/topic-navigation';
import SelectContentType from '@/components/content-v2/select-content-type';
import PageHeaderRender from '@/components/content-v2/templates/common/page-header-render';
import EmptyAssociatedWarn from '@/components/ui/empty-associated-warn';

import ContentType from '@/helpers/contentType';

export default {
  mixins     : [CourseMixin, ContentMixin, ContentSyncMixin],
  components : {
    SidebarMenu,
    TopicNavigation,
    PageHeaderRender,
    SelectContentType,
    EmptyAssociatedWarn
  },
  data() {
    return {
      isNavigationDrawerOpen: !(this.$vuetify.breakpoint.smAndDown || this.contentIsUnavailable),
      ContentType
    };
  },
  mounted() {
    this.setEqualWebPosition('left');
  },
  computed: {
    ...mapGetters({
      getterContent  : 'plataforma/newContent/getterContent',
      isImpersonated : '_core/auth/isImpersonated'
    })
  },
  methods: {
    toggleNavigationDrawer() {
      this.isNavigationDrawerOpen = !this.isNavigationDrawerOpen;
    },
    setEqualWebPosition(position) {
      this.getterUserRoleContext?.isStudent && window.interdeal?.setPosition(position);
    }
  },
  beforeDestroy() {
    this.setEqualWebPosition('right');
  }
};
